import {isTBS, isQQBrowser} from "./UA";
import {APP_INFO, browserType} from "./constant";
import TBSDownload from "./tbs-download";
import {detectStatus} from "./appdownloadUtil";
import { query } from './yUtil';

let UgGuideData = null;
window.isContentCollapsed = false; // 新闻文章不再折叠
window.ishideVideoRecommend = true; // 政府需求不能展示视频推荐模块引流

export const handleUgData = async () => {
  if (UgGuideData) {
    window.ugData = UgGuideData;
    window.appName = (query('src_app') ? browserType[query('src_app')] : "") || query('from_app');
    console.log('已有ugData', window.ugData);
    return ;
  }
  const ugData = (window._configs && window._configs.ugData && window._configs.ugData.sRspJsonData) || {};
  try {
    const { items = [] } = ugData;
    const appMap = {
      '1': 'kb',
      '9': 'qb'
    }

    if(items.length === 0) {
      return;
    }
    if(items.length === 1) {
      // console.log('命中items.length === 1');
      UgGuideData = items[0];
      window.ugData = items[0];
      window.strategy = items[0].privateInfo.strategy;
      window.appName = (query('src_app') ? browserType[query('src_app')] : query('from_app')) || appMap[items[0].dstApp];
      window.isHideHook = isQQBrowser(window.navigator.userAgent) || (query('src_app') && (query('src_app') === '2' || query('src_app') === '3' || query('src_app') === '4')) || (query('from_app') && (query('from_app') === 'kb'));      
      window.isYoungQB = query('src_app') && (query('src_app') === '4');
      return;
    }
    let selectItem = items[0];
    const installApps = {};
    for (let i=0; i<items.length; i++) {
      const item = items[i];
      const dstApp = item.dstApp;
      // console.log('获取dstApp初始状态状态', dstApp, installApps[dstApp], installApps[dstApp] !== 'undefined' );
      if (installApps[dstApp] !== 'undefined') {
        if (isTBS(window.navigator.userAgent) && window.tbs) {
          const appInfo = APP_INFO[appMap[dstApp]] || {};
          // console.log('获取appInfo安装状态', dstApp, appInfo);
          const tbsDownload = new TBSDownload(window.tbs, appInfo.downloadUrl, appInfo.pkgName, '');
          if (tbsDownload.getState() === 'installed') {
            // console.log(dstApp, '已安装');
            installApps[dstApp] = true;
          }else {
            // console.log(dstApp, '未安装');
            installApps[dstApp] = false;
          }
        }else {
          const isInstall = await detectStatus(appMap[dstApp]);
          installApps[dstApp] = isInstall ? true : false;
        }
      }
      // console.log('获取dstApp安装状态', installApps[dstApp]);
      if ((item.privateInfo.useUG === 1 && !installApps[dstApp]) || (item.privateInfo.useUG === 2 && installApps[dstApp])) {
        // console.log('更改选中任务', item);
        selectItem = item;
        break;
      }
    }
    // console.log('取中的任务',  selectItem);
    UgGuideData = selectItem;
    window.ugData = selectItem;
    window.strategy = selectItem.privateInfo.strategy;
    window.appName = (query('src_app') ? browserType[query('src_app')] : query('from_app')) || appMap[items[0].dstApp];
    window.isHideHook = isQQBrowser(window.navigator.userAgent) || (query('src_app') && (query('src_app') === '2' || query('src_app') === '3')) || (query('from_app') && (query('from_app') === 'kb'));
  }catch (e) {

  }
};

export const getUgData = async (params = {}, ) => {
  let url;
  const host = window.location.host;
  if(host.indexOf('.sparta.html5.qq.com') > -1 ){
    url = "//upage.sparta.html5.qq.com/ug-common-data"
  }else if(host.startsWith("gray")){
    url = "//grayupage.sparta.html5.qq.com/ug-common-data"
  }else{
    url = "//upage.html5.qq.com/ug-common-data"
  }
  return window.fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: JSON.stringify(params)
  });
};
